module.exports = __webpack_public_path__ + "5f6858f969354ae60d4c2c648e160262.png";